// extracted by mini-css-extract-plugin
export default {"title":"c70053994f","inner_title":"b38198dcc7","charge_btn":"_2d74d1a331"};